export default __webpack_public_path__ + "static/videobgr01-3dcc74414dfefb0b20df424a3e792f03.mp4";